import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import {DictionaryEntry} from '../../models/dictionary.model';
import {UsersService} from '../user/users.service';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class DictionaryService {

  public baseUrl = HttpClientService.BASE_MS_AUTH + '/dictionary';
  private cachedFields: Observable<any>;

  constructor (
    private http: HttpClientService,
    private usersSrv: UsersService
  ) { }

  get(id): Observable<DictionaryEntry> {
    return this.http.get(this.baseUrl + '/' + id);
  }

  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<Array<DictionaryEntry>> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    return this.http.getPaged(this.baseUrl + '?' + params.toString());
  }

  update(de: DictionaryEntry): Observable<DictionaryEntry> {
    console.log('dictionary.update', de);
    return this.http.put(this.baseUrl + '/' + de.id, de).map(res => {
      return res;
    });
  }

  create(de: DictionaryEntry): Observable<DictionaryEntry> {
    console.log('dictionary.create', de);
    return this.http.post(this.baseUrl, de).map(res => {
      return res;
    });
  }

  remove(de: DictionaryEntry): Observable<DictionaryEntry> {
    console.log('dictionary.remove', de);

    return this.http.delete(this.baseUrl + '/' + de.id).map(res => {
      return res;
    });
  }

  recover(de: DictionaryEntry): Observable<DictionaryEntry> {
    console.log('dictionary.remove', de);

    return this.http.put(this.baseUrl + '/' + de.id + '/recover', {}).map(res => {
      return res;
    });
  }

  duplicate(de: DictionaryEntry): Observable<DictionaryEntry> {
    let company_id = de.company_id;
    let data = de;
    delete data.company_id;
    console.log('dictionary.duplicate', data);

    return this.http.post(this.baseUrl + '/duplicate/' + company_id, data).map(res => {
      return res;
    });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('/koncentro-auth/schema/DictionaryDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dictionary/dictionary.service.ts